// DS: C44
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import UserAvatar from '../Avatar/UserAvatar';
import UserLink from '../Link/UserLink';
import DeviationDumbView from '../../DeviationViews/Dumbo/MinimalDumbo';
import Button from '../../Button/Button';
import ProfileOwnerWatchButton from '../../Button/ProfileOwnerWatchButton';
import DeviationLink from '../../Duperbrowse/DeviationLink';
import { getInfoToDisplayImageDeviation } from '../../DeviationViews/Dumbo/Image/_helpers';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import { useVerification } from '../../VerificationPopup/withVerification';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import MonetizationPromoStrip from './MonetizationPromoStrip';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import s from './UserAvatarPopoverContent.scss';
var getBackgroundUrl = function (deviation) {
    var info = getInfoToDisplayImageDeviation({
        deviation: deviation,
        width: parseInt(s['background-picture-width']),
    });
    if (info) {
        return info.pickedImage.src;
    }
};
export var UserAvatarPopoverContent = function (_a) {
    var _b;
    var user = _a.user, showMonetizationPromo = _a.showMonetizationPromo, _c = _a.deviationsCount, deviationsCount = _c === void 0 ? 0 : _c, deviations = _a.featuredDeviations, withButtons = _a.withButtons, relatedItemBiData = _a.relatedItemBiData, onStartChat = _a.onStartChat;
    var showBlocked = useDeviationMatureFilter((_b = user === null || user === void 0 ? void 0 : user.profile) === null || _b === void 0 ? void 0 : _b.profilePic).showBlocked;
    var _d = useVerification(), isVerificationNeeded = _d.isVerificationNeeded, pushVerificationPopup = _d.pushVerificationPopup;
    var t = useTranslation().t;
    if (!user) {
        return null;
    }
    var username = user.username, profile = user.profile, stats = user.stats;
    var watchersCount = (stats && stats.watchers) || 0;
    var deviationStyle = {};
    var deviationClassNames = [];
    var backgroundImageSrc;
    if (profile === null || profile === void 0 ? void 0 : profile.profilePic) {
        backgroundImageSrc = getBackgroundUrl(profile.profilePic);
    }
    if (backgroundImageSrc) {
        deviationStyle.backgroundImage = "url('".concat(backgroundImageSrc, "')");
    }
    else {
        deviationClassNames.push(s['no-image']);
    }
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
        React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: classnames(s['content-with-background']) },
                React.createElement("div", { className: classnames(s['content-background'], showBlocked && s['mature-blur'], deviationClassNames), style: deviationStyle }),
                showMonetizationPromo && (React.createElement(MonetizationPromoStrip, { monetizationPromo: showMonetizationPromo })),
                React.createElement("div", { className: classnames(s['content-info']) },
                    React.createElement("div", { "data-hook": BiDataHook.USER_AVATAR_TOOLTIP, className: s['content-with-mask'] },
                        React.createElement(UserAvatar, { user: user, size: 50 }),
                        React.createElement(UserLink, { className: s['username'], user: user }),
                        profile && profile.tagline && (React.createElement("div", { className: s['tagline'] }, profile.tagline)),
                        React.createElement("div", { className: s['stats'] },
                            React.createElement("div", { className: s['stat-item'] }, t('avatar.deviations', {
                                formattedCount: shortenNumber(deviationsCount),
                                count: deviationsCount,
                            })),
                            React.createElement("div", { className: s['stat-item'] }, ' | '),
                            React.createElement("div", { className: s['stat-item'] }, t('avatar.watchers', {
                                formattedCount: shortenNumber(watchersCount),
                                count: watchersCount,
                            })))))),
            React.createElement("div", { className: s['featured-buttons-wrapper'] },
                React.createElement("div", { className: s['deviations'] },
                    deviations &&
                        deviations.length > 0 &&
                        deviations.slice(0, 4).map(function (deviation) { return (React.createElement(DeviationLink, { key: deviation.deviationId, deviation: deviation, title: deviation.title, className: s['deviation-item'] },
                            React.createElement(DeviationDumbView, { width: parseInt(s['deviation-item-width']), height: parseInt(s['deviation-item-height']), deviation: deviation }))); }),
                    React.createElement(BiLink, { href: Url.userGalleryLink({
                            username: username,
                            gallectionType: 'gallery',
                        }), className: s['see-all-link'], biData: {
                            evid: BiEventType.SEE_ALL_CLICK,
                            creatorid: user.useridUuid,
                        } }, t('avatar.seeAll'))),
                withButtons && (React.createElement("div", { className: s['buttons-block'] },
                    React.createElement(Button, { className: classnames(s['button-message'], s['button-item']), view: "b2", height: "medium", onClick: isVerificationNeeded
                            ? function () { return pushVerificationPopup('chat'); }
                            : function () { return onStartChat(user); }, biData: {
                            evid: BiEventType.SEND_CHAT_BUTTON_CLICK,
                            typeid: relatedItemBiData === null || relatedItemBiData === void 0 ? void 0 : relatedItemBiData.typeid,
                            itemid: relatedItemBiData === null || relatedItemBiData === void 0 ? void 0 : relatedItemBiData.itemid,
                            friend_id: user.useridUuid,
                        } }, t('common.chat')),
                    React.createElement(Flag, { condition: "redesigned_avatar_popup", render: function () { return (React.createElement(ProfileOwnerWatchButton, { user: user, initialData: {
                                isWatching: !!user.isWatching,
                                isLoading: false,
                            }, height: "medium", className: s['button-item'], view: "b14-1" })); }, fallbackComponent: function () { return (React.createElement(ProfileOwnerWatchButton, { user: user, initialData: {
                                isWatching: !!user.isWatching,
                                isLoading: false,
                            }, height: "medium", className: s['button-item'], useV2Styles: false })); } })))))));
};
export default UserAvatarPopoverContent;
//# sourceMappingURL=UserAvatarPopoverContent.js.map